<template>
    <div :class="['to-do-item card mb-0 shadow-sm', { 'mt-2': index !== 0, 'team-leader': [5, 15].includes(role), 'no-drag': !isDraggable }]" 
         @mouseenter="setupHoverListeners" 
         @mouseleave="cleanupHoverListeners" 
         ref="todoItem">
      <div v-if="showAttention(item, columnType)" class="card-header bg-red p-0">
        <div class="d-flex align-items-center justify-content-center attention-badge">
          <font-awesome-icon :icon="['fas', 'exclamation-triangle']" class="text-white" />
          <span class="text-white">ATTENTION</span>
        </div>
      </div>
      <div class="p-3" :style="getItemCardStyle(item.label?.color)">
        <div v-if="item.label?.color" class="custom-label">
            <span class="badge rounded-pill text-white px-2" :style="{ backgroundColor: item.label?.color }">
                {{ item.label?.name }}
            </span>
        </div>

        <div class="d-flex justify-content-between align-items-center">
          <div class="d-flex align-items-center">
            <a :href="`${item.student_url}`" target="_blank" class="student-name" data-toggle="tooltip" :title="item.student_name">
              {{ getTrimmedName(item.student_name) }}
            </a>
          </div>
          <div class="d-flex align-items-center gap-2">
            <img v-if="item.flag" :src="`/images/flags/${item.flag}`" :alt="`${item.nationality}`" class="flag-img mr-2" />

            <div v-if="![5, 15].includes(role)" class="btn-dropdown-label" @click="openLabelDropdown">
              <button class="btn btn-label-color btn-sm dropdown-toggle d-flex align-items-center mt-1" type="button" data-toggle="dropdown">
                <i class="fas fa-ellipsis-v"></i>
              </button>
              <div class="dropdown-menu dropdown-menu-end p-2" @click.stop>
                <div class="d-flex justify-content-between align-items-center mb-2 px-2">
                  <strong>Labels</strong>
                  <button class="btn btn-sm btn-link p-0" @click="openAddLabelModal">
                    <i class="fas fa-plus"></i>
                  </button>
                </div>

                <div class="dropdown-divider"></div>

                        <div class="d-flex align-items-center justify-content-between px-2 py-1">
                            <div class="d-flex align-items-center" @click.stop="selectCardLabel(null)">
                              <input type="radio" name="label" value="default" v-model="selectedLabelId" class="select-label-checker mr-2">
                              <span class="badge rounded-pill text-secondary px-2 py-1" style="background-color: #f8f9fa;">
                                    Default
                                </span>
                            </div>
                        </div>

                        <div v-for="(label, index) in savedLabels" :key="index" class="d-flex align-items-center justify-content-between px-2 py-1">
                            <div class="d-flex align-items-center" @click.stop="selectCardLabel(label)">
                                <input type="radio" name="label" :value="label.id" v-model="selectedLabelId" class="select-label-checker mr-2">
                                <span class="badge rounded-pill text-white px-2 py-1" :style="{ backgroundColor: label.color }">
                                    {{ label.name }}
                                </span>
                            </div>
                            <div class="d-flex align-items-center">
                                <button class="btn btn-sm btn-link text-info p-0 mr-2" @click="openEditLabelModal(label)">
                                    <font-awesome-icon :icon="['fal', 'pen']" />
                                </button>
                                <button class="btn btn-sm btn-link text-danger p-0" @click="deleteCardLabel(label)">
                                    <font-awesome-icon :icon="['fal', 'trash-can']" />
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="d-flex justify-content-between align-items-center my-2">
          <div v-if="showActionButton(item, role, columnType)" class="dropdown">
            <button class="btn btn-action dropdown-toggle" type="button" id="action" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              Action
            </button>
            <div class="dropdown-menu" aria-labelledby="action">
              <template v-if="[5, 15].includes(role) && showAttention(item, columnType)">
                <a class="dropdown-item" v-if="columnType !== 'journeys'" href="#" @click.prevent="openTransferConsultantModal">Transfer Consultant</a>
              </template>
              <template v-if="columnType === 'journeys' && ![5, 15].includes(role)">
                <template v-if="item.category === 'ticket'">
                  <a class="dropdown-item" href="#" @click.prevent="openFollowUpModal">Follow Up</a>
                </template>
                <template v-else-if="item.agenda">
                  <a class="dropdown-item" href="#" @click.prevent="$emit('done', item.id)">Mark as seen</a>
                  <a class="dropdown-item" href="#" @click.prevent="openFollowUpModal">Follow Up</a>
                </template>
                <template v-else-if="item.category === 'visa_expiration'">
                  <a class="dropdown-item" href="#" @click.prevent="openFollowUpModal">Follow Up</a>
                  <a class="dropdown-item" v-if="![5, 15].includes(role)" :href="`${item.student_url}#visa-applications`" target="_blank">Add Extension</a>
                  <a class="dropdown-item" v-if="![5, 15].includes(role)" href="#" @click.prevent="openSendToLostModal('Send to No Renewal')">Send to No Renewal</a>
                </template>
                <template v-else-if="item.unpaid_payment || showBirthdayLabel(item)">
                  <a class="dropdown-item" href="#" @click.prevent="openContactedModal">Contacted</a>
                  <a class="dropdown-item" href="#" @click.prevent="openFollowUpModal">Follow Up</a>
                </template>
                <template v-else>
                  <a class="dropdown-item" href="#" @click.prevent="$emit('done', item.id)">Mark as seen</a>
                  <a class="dropdown-item" href="#" @click.prevent="openFollowUpModal">Follow Up</a>
                </template>
              </template>
              <template v-else>
                <template v-if="item.category === 'ticket'">
                  <a class="dropdown-item" href="#" @click.prevent="openFollowUpModal">Follow Up</a>
                </template>
                <template v-if="showSeenButton(item)">
                  <a class="dropdown-item" href="#" @click.prevent="$emit('seen', item.id)">Mark as seen</a>
                </template>
                <template v-if="canApprove(item, role)">
                  <a class="dropdown-item" href="#" @click.prevent="$emit('save', item.id, 'approve', item.is_waiting_approval_for_follow_up ? 'follow-up' : 'send-to-lost')">Approve</a>
                  <a class="dropdown-item" href="#" @click.prevent="openDeclineModal">Decline</a>
                </template>
                <template v-if="canCancelSendToLost()">
                  <a class="dropdown-item" href="#" @click.prevent="cancelSendToLost">Cancel Send to {{ item.status_transfer_request?.model_status }}</a>
                </template>
                <template v-if="canTakeActions(item, role)">
                  <a v-if="item.button_done" class="dropdown-item" href="#" @click.prevent="$emit('done', item.id)">Mark as seen</a>
                  <a v-if="columnType !== 'losts'" class="dropdown-item" href="#" @click.prevent="openFollowUpModal">Follow Up</a>
                  <a v-if="![5, 15].includes(role) && columnType === 'leads'" class="dropdown-item" href="#" @click.prevent="openConvertToProspectModal">Convert to Prospect</a>
                  <a v-if="![5, 15].includes(role) && columnType === 'prospects'" class="dropdown-item" :href="`${item.student_url}#quotation`" target="_blank">Create Quotation</a>
                  <a v-if="![5, 15].includes(role) && columnType !== 'losts'" class="dropdown-item" href="#" @click.prevent="openSendToLostModal()">Send to Lost</a>
                </template>
              </template>
            </div>
          </div>
          <span v-if="(columnType === 'quotations' && item.quotation_status) || (columnType === 'losts' && item.todoable_type)" :class="['badge', 'badge-status', 'rounded-pill', columnType === 'quotations' ? item.quotation_status : item.todoable_type, item.type === 'journey'? 'journey' : '', !showActionButton(item, role, columnType) ? 'ml-0' : '']">
            {{ getStatusLabel(columnType === 'quotations' ? item.quotation_status : item.todoable_type, item.type) }}
          </span>
        </div>

        <div v-if="showLabel(item)" class="mb-2">
          <!-- Influencer/Hunter -->
          <template v-if="item.category === 'influencer'">
            <button class="btn btn-agenda-label btn-xs btn-outline text-capitalize" :ref="`influencerLabel-${item.id}`">
              <i :class="getAgendaIcon(item.influencer?.type)" class="mr-1"></i>
              <span>{{ item.influencer?.type }} {{ getCardLabel(item, role) }}</span>
            </button>
          </template>

          <!-- Reference -->
          <template v-else-if="item.category === 'reference'">
            <button class="btn btn-agenda-label btn-xs btn-outline text-capitalize" :ref="`referenceLabel-${item.id}`">
              <i :class="getAgendaIcon(item.category)" class="mr-1"></i>
              <span>Reference {{ getCardLabel(item, role) }}</span>
            </button>
          </template>

          <!-- Self Reminder -->
          <template v-else-if="item.category === 'reminder'">
            <button class="btn btn-agenda-label btn-xs btn-outline text-capitalize" :ref="`reminderLabel-${item.id}`">
              <i :class="getAgendaIcon(item.category)" class="mr-1"></i>
              <span>Self Reminder {{ getCardLabel(item, role) }}</span>
            </button>
          </template>


          <!-- Visa Expiration -->
          <template v-else-if="item.category === 'visa_expiration'">
            <button class="btn btn-agenda-label btn-xs btn-outline text-capitalize">
              <i class="fas fa-passport"></i>
              <span>Visa Exp. {{ getCardLabel(item, role) }}</span>
            </button>
          </template>

          <!-- Event -->
          <template v-else-if="item.category === 'event'">
            <button class="btn btn-agenda-label btn-xs btn-outline text-capitalize" :ref="`eventLabel-${item.id}`">
              <font-awesome-icon :icon="['fas', 'calendar-star']" />
              <span>Event {{ getCardLabel(item, role) }}</span>
            </button>
          </template>

          <!-- Agenda -->
          <template v-else-if="item.agenda">
            <button class="btn btn-xs btn-outline text-capitalize" :class="[item.category === 'calendar' ? 'btn-todo-label' : 'btn-agenda-label']">
              <i :class="getAgendaIcon(item.agenda?.agenda_type)" class="mr-1"></i>
              <span>
                {{ getAgendaLabel(item.agenda?.agenda_type, item.category) }} 
                {{ canApprove(item, role) ? item.agenda?.date : '' }} 
                {{ formatTime(item.agenda?.time) }}
              </span>
            </button>
          </template>

          <!-- Ticket -->
          <template v-else-if="columnType === 'prospects' && item.category === 'ticket'">
            <button class="btn btn-agenda-label btn-xs btn-outline text-capitalize">
              <i class="fas fa-ticket"></i>
              <span>Ticket {{ getCardLabel(item, role) }}</span>
            </button>
          </template>

          <!-- Journey column handling -->
          <template v-else-if="columnType === 'journeys'">
            <button v-if="item.category === 'ticket'" class="btn btn-agenda-label btn-xs btn-outline text-capitalize">
              <i class="fas fa-ticket"></i>
              <span>Ticket {{ getCardLabel(item, role) }}</span>
            </button>
            <button v-else-if="item.unpaid_payment" class="btn btn-agenda-label btn-xs btn-outline text-capitalize">
              <i class="fas fa-money-bill"></i>
              <span>Unpaid {{ getCardLabel(item, role) }}</span>
            </button>
            <button v-else-if="item.category === 'visa_expiration'" class="btn btn-agenda-label btn-xs btn-outline text-capitalize">
              <i class="fas fa-passport"></i>
              <span>Visa Exp. {{ getCardLabel(item, role) }}</span>
            </button>
            <button v-else-if="showBirthdayLabel(item)" class="btn btn-agenda-label btn-xs btn-outline text-capitalize">
              <i class="fas fa-birthday-cake"></i>
              <span>Birthday {{ getCardLabel(item, role) }}</span>
            </button>
          </template>

          <!-- Default New -->
          <template v-else>
            <button class="btn btn-new-lead btn-xs btn-outline">
              <font-awesome-icon :icon="['fas', 'sparkles']" /> <span>New {{ getCardLabel(item, role) }}</span>
            </button>
          </template>
        </div>

        <div v-if="item.category === 'ticket' && item.ticket" class="ticket-subject small mb-2">
          <div class="d-flex align-items-center justify-content-between">
            <div class="mb-1 flex-grow-1 overflow-hidden">
              <span class="status-key">Subject:</span>
              <p class="mb-0 text-wrap">{{ item.ticket?.subject }}</p>
            </div>
            <a :href="item.ticket?.url" alt="Open Ticket" class="open-ticket" target="_blank">
              <font-awesome-icon :icon="['fas', 'external-link']" />
            </a>
          </div>
        </div>

        <div class="row small">
          <template v-if="columnType === 'journeys'">
            <div class="col-12 text-left text-wrap">
              <div class="text-capitalize">
                <span>Status: <strong>{{ item.student_status || '-' }}</strong></span>
              </div>
              <div v-if="item.category === 'birthday' && item.date_of_birth" class="text-capitalize">
                <span>Birthday on <strong>{{ formatBirthday(item.date_of_birth) }}</strong></span>
              </div>
              <div v-if="item.category === 'visa_expiration' && item.visa_exp" class="text-capitalize">
                <span>Visa exp. <strong>{{ formatMonthYear(item.visa_exp) }}</strong></span>
              </div>
              <div v-if="item.category === 'unpaid'" class="text-capitalize">
                <span>Installment <strong>{{ item.unpaid_payment?.amount }} {{ item.unpaid_payment?.currency }}</strong></span>
              </div>
              <div v-if="item.category === 'unpaid' && item.unpaid_payment?.due_date" class="text-capitalize">
                <span>Overdue <strong>{{ item.unpaid_payment?.due_date }}</strong></span>
              </div>
            </div>
          </template>
          <template v-else>
            <div v-if="item.category === 'influencer' || item.category === 'reference'" class="col-12 text-nowrap">
              <span v-if="item.influencer?.type === 'influencer'" class="text-capitalize">
                Influencer: <strong>{{ item.influencer?.name }}</strong>
              </span>
              <span v-if="item.influencer?.type === 'hunter'" class="text-capitalize">
                Hunter: <strong>{{ item.influencer?.name }}</strong>
              </span>
              <span v-if="item.category === 'reference'" class="text-capitalize">
                Reference:
                <a :href="`${item.reference?.link}`" target="_blank" class="text-decoration-none">
                  <strong>{{ item.reference?.name }}</strong>
                </a>
              </span>
            </div>
            <div class="col-7 text-left text-wrap">
              <div class="text-capitalize">
                <span>Type <strong>{{ item.student_type }}</strong></span>
              </div>
              <div class="text-capitalize">
                <span>Source <strong>{{ item.sub_source || item.source || '-' }}</strong></span>
              </div>
            </div>
            <div class="col-5 text-right text-wrap pl-0">
              <div>{{ getDateLabel(columnType) }} <strong>{{ getRelevantDate(columnType) }}</strong></div>
              <div v-if="columnType === 'leads' && item.agenda_type === 'unconfirmed'">
                <span>Assign. Date <strong>{{ item.assign_date || '-' }}</strong></span>
              </div>
              <div v-else-if="item.agenda">
                <span>Appt. Date <strong>{{ item.agenda?.date || '-' }}</strong></span>
              </div>
              <div><span>Visa Exp. <strong>{{ item.visa_exp || '-' }}</strong></span></div>
            </div>
          </template>
        </div>

        <hr class="divider" />

        <div class="row small">
          <div class="col-6 pr-0">
            <template v-if="item.status_transfer_request?.model_status === 'Lost' || item.status_transfer_request?.model_status === 'No Renewal'">
              <span class="badge badge-status rounded-pill expired">
                  {{ item.status_transfer_request?.model_status }}
              </span>
            </template>
            <template v-else>
              <div v-if="item.status === 'done' && !item.is_lost" class="d-block mb-1">
                <span class="badge badge-status rounded-pill students">
                    Done
                </span>
              </div>
              <a @click="openFollowUpLogsModal" class="follow-up-logs">
                Follow up <span class="text-danger font-weight-bold">({{ item.total_follow_ups || 0 }})</span>
              </a>
              <div class="font-italic">{{ item.last_follow_up?.datetime || '-' }}</div>
            </template>
          </div>
          <div class="col-6 communication-icons pl-0">
            <div class="d-flex flex-wrap justify-content-end">
              <div class="d-flex align-items-center mr-2">
                <i class="fab fa-whatsapp mr-1 text-secondary"></i> <span>{{ item.total_whatsapps || 0 }}</span>
              </div>
              <div class="d-flex align-items-center mr-2">
                <i class="fas fa-phone mr-1 text-secondary"></i> <span>{{ item.total_voice_calls || 0 }}</span>
              </div>
              <div class="d-flex align-items-center mr-2">
                <i class="fas fa-video mr-1 text-secondary"></i> <span>{{ item.total_video_calls || 0 }}</span>
              </div>
              <div class="d-flex align-items-center mr-2">
                <i class="fas fa-envelope mr-1 text-secondary"></i> <span>{{ item.total_emails || 0 }}</span>
              </div>
            </div>
          </div>
        </div>

        <hr class="divider" />

        <div class="last-contact small">
          <div><span>Last Contact {{ getFormattedAnswerDate(item.last_contact_at) }}</span></div>
          <div><span>Last Answer {{ getFormattedAnswerDate(item.last_answer_at) }}</span></div>
        </div>

        <div v-if="item.rejected_follow_up_notes" class="follow-up-rejected small">
          <div class="row mb-1">
            <div class="col-12">
              <span class="status-key">Follow up Approval:</span>
              <p class="follow-up-declined mb-0">Decline</p>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <span class="status-key">Notes:</span>
              <p class="text-wrap mb-0">{{ item.rejected_follow_up_notes }}</p>
            </div>
          </div>
        </div>

        <div v-if="item.status_transfer_request" class="transfer-status small">
          <div v-if="item.status_transfer_request?.status === 'rejected'">
            <div v-if="item.status_transfer_request?.rejected_by" class="row mb-1">
              <div class="col-12">
                <span class="status-key">Decline Lost by:</span>
                <p class="text-wrap mb-0">{{ item.status_transfer_request?.rejected_by }}</p>
              </div>
            </div>
            <div v-if="item.status_transfer_request?.rejected_notes" class="row">
              <div class="col-12">
                <span class="status-key">Notes:</span>
                <p class="text-wrap mb-0">{{ item.status_transfer_request?.rejected_notes }}</p>
              </div>
            </div>
          </div>
          <div v-else>
            <div class="row mb-1">
              <div v-if="item.status_transfer_request?.reason" class="col-6">
                <span class="status-key">Reason:</span>
                <p class="text-wrap mb-0">{{ item.status_transfer_request?.reason }}</p>
              </div>
              <div class="col-6">
                <span class="status-key">{{ item.status_transfer_request?.model_status }} Approval:</span>
                <div v-if="item.status_transfer_request?.status === 'approved'">
                  <p class="text-wrap mb-0">{{ item.status_transfer_request?.approved_by }}</p>
                </div>
                <div v-else>
                  <p class="text-wrap mb-0 text-danger font-italic">Waiting for Approval..</p>
                </div>
              </div>
            </div>
            <div v-if="item.status_transfer_request?.notes" class="row">
              <div class="col-12">
                <span class="status-key">Notes:</span>
                <p class="text-wrap mb-0">{{ item.status_transfer_request?.notes }}</p>
              </div>
            </div>
          </div>
        </div>

        <add-edit-card-label-modal ref="addEditLabelModal" @save="saveCardLabel" />
      </div>
    </div>
</template>

<script>
    import AddEditCardLabelModal from './AddEditCardLabelModal.vue'
    import { getCardLabels, attachCardlabel, createUserlabel, updateUserlabel, deleteLabel } from '../../../services/api/to-do';

    export default {
        name: 'ToDoColumnItem',
        components: { AddEditCardLabelModal },
        props: {
            role: {
                type: Number,
                default: 0
            },
            consultantId: {
                type: Number,
                default: 0
            },
            userId: {
              type: Number,
              default: 0
            },
            date: {
              type: String,
              required: true,
              default: () => new Date().toISOString().slice(0, 10)
            },
            item: {
                type: Object,
                required: true
            },
            index: {
                type: Number,
                required: true
            },
            columnType: {
                type: String,
                required: true
            }
        },
        data() {
            return {
                selectedLabelId: null,
                savedLabels: [],
                isDraggable: true
            }
        },
        mounted() {
            this.initReminderTooltip();
        },
        beforeDestroy() {
            this.cleanupHoverListeners();
        },
        watch: {
            'item.note'(newVal) {
                this.initReminderTooltip();
            }
        },
        methods: {
            openFollowUpLogsModal() {
                this.$emit('follow-up-logs', this.item.id);
            },
            openFollowUpModal() {
                this.$emit('follow-up', this.item);
            },
            openConvertToProspectModal() {
                this.$emit('convert-to-prospect', this.item);
            },
            openSendToLostModal(title = 'Send to Lost') {
                this.$emit('send-to-lost', { item: this.item, title: title });
            },
            openDeclineModal() {
                this.$emit('decline', this.item)
            },
            openAddLabelModal() {
                this.$refs.addEditLabelModal.openModal();
            },
            openEditLabelModal(label) {
                this.$refs.addEditLabelModal.openModal(label);
            },
            openContactedModal() {
                this.$emit('contacted', this.item);
            },
            openTransferConsultantModal() {
                const type = this.columnType === 'leads' ? 'lead' : 'student';
                this.$emit('transfer-consultant', this.item, type);
            },
            getItemCardStyle(color) {
                if (!color) {
                    return {}
                }

                const hex = color.startsWith('#') ? color.slice(1) : color

                if (hex.length !== 6) {
                    return {}
                }

                const r = parseInt(hex.substring(0, 2), 16)
                const g = parseInt(hex.substring(2, 4), 16)
                const b = parseInt(hex.substring(4, 6), 16)

                return {
                    border: `1px solid ${color}`,
                    backgroundColor: `rgba(${r}, ${g}, ${b}, 0.1)`
                }
            },
            getTrimmedName(name) {
                if (!name) return ''
                return name.length > 20 ? name.slice(0, 20) + '…' : name
            },
            getAgendaIcon(type) {
                switch (type) {
                    case 'unconfirmed':
                        return 'fas fa-clock'
                    case 'voice_call':
                        return 'fas fa-phone'
                    case 'video_call':
                        return 'fas fa-video'
                    case 'office':
                        return 'fas fa-building'
                    case 'reminder':
                        return 'fas fa-alarm-clock'
                    case 'influencer':
                        return 'fas fa-user-crown'
                    case 'hunter':
                      return 'fas fa-user-friends'
                    case 'reference':
                        return 'fas fa-people-arrows'
                    default:
                        return 'fas fa-calendar-alt'
                }
            },
            getAgendaLabel(type, category) {
                if (!type) {
                    return 'No Agenda'
                }

                if (category === 'robotin') {
                    return 'Robotin'
                }

                if (category === 'calendar') {
                    return 'Personal'
                }

                return type.replace(/_/g, ' ')
            },
            getStatusLabel(status, type) {
                if (type === 'journey') {
                  return 'Journey';
                }

                const quotationSentTime = this.columnType === 'quotations' ? this.item.quotation_sent_at : null;
                const labels = {
                    sent: 'Sent' + (quotationSentTime && this.item.category !== 'reminder' ? ` ${this.formatTime(quotationSentTime)}` : ''),
                    accepted: 'Accepted',
                    expired: 'Expired',
                    students: 'Prospect',
                    leads: 'Lead',
                };

                return labels[status] || '';
            },
            getCardLabel(item,role) {
              if ([5, 15].includes(role)){
                if (item.is_waiting_approval_for_follow_up){
                  return item.last_follow_up?.datetime_label;
                } else {
                  return item.show_datetime?.datetime_label;
                }
              } else {
                if (item.is_waiting_approval_for_follow_up){
                  return item.last_follow_up?.time_label;
                } else {
                  return item.show_datetime?.time_label;
                }
              }
            },
            getDateLabel(type) {
                if (type === 'quotations') {
                    return 'Sent Date'
                }

                return 'Reg. Date'
            },
            getRelevantDate(type) {
                const item = this.item;

                if (type === 'quotations') {
                    return item.quotation_sent_at || '-';
                }

                return item.reg_date || '-'
            },
            getFormattedAnswerDate(value) {
                if (!value) {
                    return '-';
                }

                const [datePart, timePart, meridian] = value.split(' ');
                const [year, month, day] = datePart.split('-');

                return `${day}/${month}/${year} ${timePart} ${meridian}`;
            },
            showActionButton(item, role, columnType) {
                if (this.showSeenButton(item)) {
                    return true;
                }

                const status = item.status_transfer_request?.status;

                if ([5, 15].includes(role)) {
                    if (['approved', 'rejected'].includes(status)) {
                        return false;
                    }

                    return status === 'pending' || item.is_waiting_approval_for_follow_up || item.is_overdue;
                }

                return (columnType === 'losts' && status === 'pending') || (columnType !== 'losts' && !item.is_overdue);
            },
            canApprove(item, role) {
              return [5, 15].includes(role) && (item.status_transfer_request?.status === 'pending' || item.is_waiting_approval_for_follow_up);
            },
            canTakeActions(item, role) {
              if(item.category === 'ticket'){
                return false;
              }
              return item.status !== 'done' && ((![5, 15].includes(role) &&  !item.is_overdue) || ([5, 15].includes(role) && item.is_overdue && !(item.status_transfer_request?.status === 'pending' || item.is_waiting_approval_for_follow_up)));
            },
            canCancelSendToLost() {
              return this.columnType === 'losts' && this.item.status_transfer_request?.status === 'pending';
            },
            cancelSendToLost() {
                this.$emit('cancel-send-to-lost', this.item.id);
            },
            async openLabelDropdown() {
                await this.fetchCardLabels();
            },
            async fetchCardLabels() {
                try {
                    const response = await getCardLabels([5, 15].includes(this.role) ? this.consultantId : this.userId);
                    this.savedLabels = response.data.data || [];

                    // Find the matching label if it exists
                    const selectedLabel = this.item.label && this.savedLabels.length > 0 
                        ? this.savedLabels.find(label =>
                            label.color === this.item.label.color &&
                            label.name === this.item.label.name
                        )
                        : null;

                    // Set selectedLabelId to the matching label's id or 'default'
                    this.selectedLabelId = selectedLabel ? selectedLabel.id : 'default';
                } catch (error) {
                    console.error("Error fetching card labels:", error);
                }
            },
            async selectCardLabel(label) {
                this.selectedLabelId = label ? label.id : 'default';

                const payload = {
                    todo_board_id: this.item.id,
                    label_id: label ? label.id : null
                };

                try {
                    const response = await attachCardlabel(payload);

                    if (response.status === 200 || response.status === 201) {
                        this.$emit('refresh-columns');
                    } else {
                        new Noty({
                            type: 'error',
                            text: response.data.message || 'Failed to attach label.'
                        }).show();
                    }
                } catch (error) {
                    console.error('Error attaching label:', error);
                    new Noty({
                        type: 'error',
                        text: 'An error occurred while attaching the label.'
                    }).show();
                }
            },
            async saveCardLabel(label) {
                const payload = {
                    name: label.name,
                    color: label.color
                };

                try {
                    let response;

                    if (label.id) {
                        response = await updateUserlabel(label.id, payload);
                    } else {
                        response = await createUserlabel(payload);
                    }

                    if (response.status === 200 || response.status === 201) {
                        this.$emit('refresh-columns');
                    } else {
                        new Noty({
                            type: 'error',
                            text: response.data.message || 'Failed to save label.'
                        }).show();
                    }
                } catch (error) {
                    console.error(`Failed to save card label.`, error);
                    this.$emit('refresh-columns');

                    new Noty({
                        type: "error",
                        text: "Failed to save label."
                    }).show();
                }
            },
            async deleteCardLabel(label) {
                try {
                    const response = await deleteLabel(label.id);

                    if (response.status === 200 || response.status === 201) {
                        this.savedLabels = this.savedLabels.filter(l => l.id !== label.id);

                        // If the deleted label was selected, set to default
                        if (this.selectedLabelId === label.id) {
                            this.selectedLabelId = 'default';
                        }
                        this.$emit('refresh-columns');
                    } else {
                        new Noty({
                            type: "error",
                            text: response.data.message || 'An error occurred.'
                        }).show();
                    }
                } catch (error) {
                    console.error(`Failed to delete card label.`, error);

                    let errorMessage = "Failed to delete label.";

                    if (error.response) {
                        const status = error.response.status;

                        if (status === 400) {
                            errorMessage = error.response.data.message || "Bad request.";
                        } else if (status === 422) {
                            const errors = error.response.data.errors;
                            errorMessage = Object.values(errors).flat().join('\n') || "Validation failed.";
                        }
                    }

                    new Noty({
                        type: "error",
                        text: errorMessage
                    }).show();
                }
            },
            showAttention(item, columnType) {
              return item.is_overdue &&
                columnType !== 'losts' &&
                item.status !== 'done' &&
                item.is_waiting_approval_for_follow_up === false &&
                item.status_transfer_request?.status !== 'pending';
            },
            showSeenButton(item) {
              const isAllowedRole = [5, 15].includes(this.role);
              const isOverdue = item.is_overdue;
              const isAllowedStatus = ['pending', 'done'].includes(item.status);
              const isWaitingFollowUpApproval = item.is_waiting_approval_for_follow_up;
              const isTicket = item.ticket && item.category === 'ticket';
              const inLeads = this.columnType === 'leads';
              const inProspects = this.columnType === 'prospects';
              const inQuotations = this.columnType === 'quotations';
              const inJourneys = this.columnType === 'journeys';
              const inLosts = this.columnType === 'losts';
              const hasTransferRequest = item.status_transfer_request;

              // Grouped conditions
              const showInLeads = isAllowedRole && inLeads && isAllowedStatus && !isOverdue && !isWaitingFollowUpApproval && (!hasTransferRequest || (hasTransferRequest && hasTransferRequest.status !== 'pending')) && !isTicket;
              const showInProspects = isAllowedRole && inProspects && isAllowedStatus && !isOverdue && !isWaitingFollowUpApproval && (!hasTransferRequest || (hasTransferRequest && hasTransferRequest.status !== 'pending')) && !isTicket;
              const showInQuotations = isAllowedRole && inQuotations && isAllowedStatus && !isOverdue && !isWaitingFollowUpApproval && (!hasTransferRequest || (hasTransferRequest && hasTransferRequest.status !== 'pending')) && !isTicket;
              const showInJourneys = isAllowedRole && inJourneys && isAllowedStatus && !isOverdue && !isWaitingFollowUpApproval && (!hasTransferRequest || (hasTransferRequest && hasTransferRequest.status !== 'pending')) && !isTicket;
              const showInLosts = isAllowedRole && inLosts && isAllowedStatus && !isOverdue && !isWaitingFollowUpApproval && !hasTransferRequest && !isTicket;

              return (showInLeads || showInProspects || showInQuotations || showInJourneys || showInLosts);
            },
            formatTime(value) {
              if (!value) {
                return '';
              }

              if (/^\d{1,2}:\d{2}$/.test(value)) {
                const [hours, minutes] = value.split(':').map(Number);
                const date = this.date ? new Date(this.date) : new Date();
                date.setHours(hours, minutes, 0, 0);
                return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: true });
              }

              const date = new Date(value);
              return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: true });
            },
            initReminderTooltip() {
                this.$nextTick(() => {
                    const ref = `reminderLabel-${this.item.id}`;
                    const element = this.$refs[ref];

                    if (element && this.item.note) {
                        const $el = $(element);

                        $el.tooltip('dispose');
                        $el.tooltip({
                            html: true,
                            customClass: 'reminder-label',
                            title: this.item.note,
                            trigger: 'hover focus',
                            placement: 'bottom'
                        });
                    }
                });
            },
            showLabel(item) {
              return this.columnType !== 'quotations' || item.category === 'reminder';
            },
            showBirthdayLabel(item) {
                if (!item.category === 'birthday') {
                  return false;
                }

                const dob = new Date(item.date_of_birth);
                const showDate = new Date(item.show_datetime.datetime);
                return (dob.getDate() === showDate.getDate() && dob.getMonth() === showDate.getMonth());
            },
            formatBirthday(dateOfBirth) {
                if (!dateOfBirth) {
                  return '-';
                }

                const date = new Date(dateOfBirth);
                const month = date.toLocaleString('default', { month: 'long' });
                const day = date.getDate();

                const ordinal = (n) => {
                  if (n > 3 && n < 21) {
                    return 'th';
                  }

                  switch (n % 10) {
                    case 1: return 'st';
                    case 2: return 'nd';
                    case 3: return 'rd';
                    default: return 'th';
                  }
                };
                return `${month} ${day}${ordinal(day)}`;
            },
            formatMonthYear(date) {
                const cleaned = date.replace(/\\/g, "");
                const [, month, year] = cleaned.split("/");

                return `${month}/${year}`;
            },
            setupHoverListeners() {
                if ([5, 15].includes(this.role)) {
                    return;
                }

                this.$nextTick(() => {
                    if (this.$refs.todoItem) {
                        this.addInteractiveListeners();
                    }
                });
            },
            cleanupHoverListeners() {
                this.isDraggable = true;
                this.$emit('drag-state-change', this.item.id, true);
                this.removeInteractiveListeners();
            },
            addInteractiveListeners() {
                if (!this.$refs.todoItem) {
                    return;
                }

                // Define interactive and text elements
                const interactiveSelectors = [
                    'a', 'button', 'input', 'select', 'textarea', '.dropdown-toggle', '.btn', '.badge'
                ];

                const textSelectors = [
                    'p', 'span', '[class*="text-"]'
                ];

                // Add listeners to interactive elements
                interactiveSelectors.forEach(selector => {
                    const elements = this.$refs.todoItem.querySelectorAll(selector);

                    elements.forEach(el => {
                        el.addEventListener('mouseenter', this.onInteractiveEnter);
                        el.addEventListener('mouseleave', this.onInteractiveLeave);
                    });
                });

                // Add listeners to text elements for text selection
                textSelectors.forEach(selector => {
                    const elements = this.$refs.todoItem.querySelectorAll(selector);

                    elements.forEach(el => {
                        el.addEventListener('mouseenter', this.onTextEnter);
                        el.addEventListener('mouseleave', this.onTextLeave);
                    });
                });
            },
            removeInteractiveListeners() {
                if (!this.$refs.todoItem) {
                    return;
                }

                const allSelectors = [
                    'a', 'button', 'input', 'select', 'textarea', '.dropdown-toggle', '.btn', '.badge', 'p', 'span', '[class*="text-"]'
                ];

                allSelectors.forEach(selector => {
                    const elements = this.$refs.todoItem.querySelectorAll(selector);

                    elements.forEach(el => {
                        el.removeEventListener('mouseenter', this.onInteractiveEnter);
                        el.removeEventListener('mouseleave', this.onInteractiveLeave);
                        el.removeEventListener('mouseenter', this.onTextEnter);
                        el.removeEventListener('mouseleave', this.onTextLeave);
                    });
                });
            },
            onInteractiveEnter() {
                // When hovering over interactive elements (buttons, links), disable dragging
                this.isDraggable = false;
                this.$emit('drag-state-change', this.item.id, false);
            },
            onInteractiveLeave() {
                // When leaving interactive elements, enable dragging
                this.isDraggable = true;
                this.$emit('drag-state-change', this.item.id, true);
            },
            onTextEnter() {
                // When hovering over text elements, disable dragging to allow text selection
                this.isDraggable = false;
                this.$emit('drag-state-change', this.item.id, false);
            },
            onTextLeave() {
                // When leaving text elements, enable dragging
                this.isDraggable = true;
                this.$emit('drag-state-change', this.item.id, true);
            }
        }
    }
</script>
